module.exports = __webpack_public_path__ + "static/media/fireworks.31beaf21.mp4";